import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Clients } from '@/features/clients'
import { requireActiveSubscription } from '@/lib/middleware'

const clientsSearchSchema = z.object({
  view: z.enum(['cards', 'list']).optional().catch('cards'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  search: z.string().optional().catch(''),
  status: z
    .array(z.enum(['active', 'inactive', 'expiring_soon']))
    .optional()
    .catch([]),
  // Membership status — a different axis from `status` (the support state).
  // Absent = the server default (everything but offboarded).
  access: z
    .array(z.enum(['active', 'suspended', 'offboarded']))
    .optional()
    .catch([]),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/clients/')({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: clientsSearchSchema,
  component: Clients,
})
